export const LIST_EQUIPMENTS_BY_INSURER = 'equipment.LIST_EQUIPMENTS_BY_INSURER'
export const SET_EQUIPMENTS_BY_INSURER = 'equipment.SET_EQUIPMENTS_BY_INSURER'

export const listEquipmentsByInsurer = () => ({
  type: LIST_EQUIPMENTS_BY_INSURER,
})

export const setEquipmentsByInsurer = (data) => ({
  type: SET_EQUIPMENTS_BY_INSURER,
  data,
})
